export class CategoriaMenu {
  uid: string;
  descrizione: string;
  descrizione_it: string;
  descrizione_en: string;
  posizione: number;
}
